import React, {useEffect, useState} from "react";
import {Chart as CharJS} from 'chart.js/auto'
import Base from "./components/Base";
import {ToastContainer, toast} from "react-toastify"
import { onMessage, getMessaging, getToken} from "firebase/messaging";
import { setDoc, getFirestore,doc, addDoc, collection } from "firebase/firestore";
import app from "./api/firebaseConf";
import 'react-toastify/dist/ReactToastify.css';

function App() {

  const messaging = getMessaging(app)
  const firestore = getFirestore(app)
  const [isTokenFound, setTokenFound] = useState(false)
  const [state, setState]  = useState('')

  const get_Token = async () => {
    let currentToken = '';

    currentToken = await getToken(messaging,{vapidKey: 'BPAngEPgGx9bwGMrR1wvvBaI4fQ9MyhcWvE0yl0Urd8bvrznEbQqP4_scJ3d9oRB3ihxwE8bUcUTTcbidkQi0RY'}).catch( error =>{
      console.log('Ha ocurrido un error recuperando el token', error)
    })

    if (currentToken){
      const set_Token = async(token) =>{
        console.log(token)
        await setDoc(doc(firestore,'token','token-user'), {token: token})
      }
      set_Token(currentToken)
      
    }else{
      console.log("no tienes token rey")
      
    }

  }

  // const set_Token = async(token) =>{
  //   console.log(token)
  //   await setDoc(doc(firestore,'token','token-user'), {token: token})
  // }

  function notifyMe() {

    if (!("Notification" in window)) {
      alert("Este navegador no es compatible con las notificaciones de escritorio");
    }

    else if (Notification.permission === "granted") {
      get_Token()
    }

    else if (Notification.permission !== "denied" || Notification.permission === "default") {
      Notification.requestPermission().then(function (permission) {

        if (permission === "granted") {
          get_Token()
        }
      });
    }

  }
  
  useEffect(()=>{
    notifyMe()
    
    

    onMessage(messaging, message => {  
      toast(message.notification.title,  {
        type: 'info',
        theme: "colored"
    })
      

    } )
  },[])
  
  return (
    <div className="bg-gray-100">
       <Base/>
       <ToastContainer/>
    </div>
  );
}

export default App;
